import {
  AfterViewInit,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { AlertMessageService } from '../alerts/alertmsg.service';

@Component({
  selector: 'app-feedbacks',
  templateUrl: './feedbacks.component.html',
  styleUrls: ['./feedbacks.component.scss'],
})
export class FeedbacksComponent implements OnInit, AfterViewInit {
  currentRate = null;
  placeholder: string = 'Leave a message, if you want (to submit press enter).';
  numbers: Array<number> = [1, 2, 3, 4, 5];
  feedbackform: FormGroup;
  displayTemplate: TemplateRef<any>;

  @ViewChild('agentfeedback') private agentfeedback: TemplateRef<any>;
  @ViewChild('custfeedback') private custfeedback: TemplateRef<any>;
  @ViewChild('tankyou') private tankyou: TemplateRef<any>;

  constructor(
    private fb: FormBuilder,
    private apiservice: ApiService,
    private router: Router,
    private alertMsg: AlertMessageService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.feedbackform = this.fb.group({
      rating: [null, Validators.required],
      review: [null],
    });
  }

  ngAfterViewInit(): void {
    if (this.apiservice.session_details.ishost) {
      this.displayTemplate = this.agentfeedback;
    } else {
      this.displayTemplate = this.custfeedback;
    }
    this.cd.detectChanges();
  }

  onRateChange(event: any) {
    console.log(event);
  }

  onFeedbackSubmit(form: FormGroup) {
    if (form.invalid) {
      return;
    }

    let payload = {
      feedback: { rating: form.value.rating, review: form.value.review },
    };
    const profileid = window.sessionStorage.getItem(
      'covniaIO.webrtc.profileId'
    );
    this.apiservice.feedbackSubmit(payload, profileid).subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          this.displayTemplate = this.tankyou;
          this.alertMsg.alertSuccess(res.message);
        }
      },
      error: (err: any) => {
        console.log('err >>> ', err);
      },
    });
  }

  goToLogin() {
    this.router.navigate([`/login`]);
  }
}
